import { AnyObject } from 'antd/es/_util/type';
import { IOrderPayment } from '../interfaces/orders';

// TODO refactor when we add installments support via payment plan with CC
export const getInstallmentsFromPlan = (paymentPlan: AnyObject) => {
  return paymentPlan?.preferences?.kind === 'credit_card'
    ? paymentPlan?.preferences?.installments
    : paymentPlan?.config?.installments[0]?.times;
};

/**
 * Checks if a payment is Principia
 * @param payment - The payment object to check
 * @returns true if the payment is Principia, false otherwise
 */
export const isPrincipiaPayment = (payment: IOrderPayment): boolean => {
  return Boolean((payment.info as { principia?: boolean })?.principia);
};

/**
 * Checks if there is a Principia payment within an array of payments
 * @param payments - Array of payment objects to check
 * @returns true if there is at least one Principia payment, false otherwise
 */
export const hasPrincipiaPayment = (payments: IOrderPayment[]): boolean => {
  return payments.some(payment => isPrincipiaPayment(payment));
};

/**
 * Gets all Principia payments from an array of payments
 * @param payments - Array of payment objects to filter
 * @returns Array of Principia payments, empty array if none found
 */
export const getPrincipiaPayments = (
  payments: IOrderPayment[]
): IOrderPayment[] => {
  return payments.filter(payment => isPrincipiaPayment(payment));
};

/**
 * Checks if a payment is external
 * @param payment - The payment object to check
 * @returns true if the payment is external, false otherwise
 */
export const isExternalPayment = (payment: IOrderPayment): boolean => {
  return payment.kind === 'external';
};

/**
 * Checks if there is an external payment within an array of payments
 * @param payments - Array of payment objects to check
 * @returns true if there is at least one external payment, false otherwise
 */
export const hasExternalPayment = (payments: IOrderPayment[]): boolean => {
  return payments.some(payment => isExternalPayment(payment));
};

/**
 * Gets all external payments from an array of payments
 * @param payments - Array of payment objects to filter
 * @returns Array of external payments, empty array if none found
 */
export const getExternalPayments = (
  payments: IOrderPayment[]
): IOrderPayment[] => {
  return payments.filter(payment => isExternalPayment(payment));
};

/**
 * Gets the Principia URL from a payment
 * @param payment - The Principia payment object
 * @returns the Principia URL from payment.info.url
 */
export const getPrincipiaUrl = (payment: IOrderPayment): string | undefined => {
  return (payment.info as { url?: string })?.url;
};
